import AppStore from '@v4/store/appStore'
import PageTemplateData from '@v4/utils/data/PageTemplateData'
import React, { useEffect, useMemo, useState } from 'react'
import { useSectionIndex } from '@v4/components/common/SectionItem/SectionItem.context'

export const useMainContainer = ({ relatedSections = [undefined, undefined], ...rootProps }) => {
	const minMarginTop = AppStore.useStoreState(state => state.ui.sectionHeights[relatedSections[0]])
	const minMarginBottom = AppStore.useStoreState(state => state.ui.sectionHeights[relatedSections[1]])
	const sectionIndex = useSectionIndex()
	const ref = React.useRef()
	const sectionLimit = +(import.meta.env.VITE_RENDERED_SECTION_COUNT || 0)
	const isBuilderMode = AppStore.useStoreState(state => state.general.isBuilderMode)
	const alwaysVisible = (window?.parent !== window && !isBuilderMode) || !sectionLimit
	const [visible, setVisible] = useState(alwaysVisible || sectionIndex < sectionLimit)

	useEffect(() => {
		if (import.meta.env.SSR || visible || !ref.current) {
			return undefined
		}
		const io = new IntersectionObserver(entries => entries[0].isIntersecting && setVisible(true), {
			rootMargin: '400px',
		})
		io.observe(ref.current)
		return () => io.disconnect()
	}, [visible])

	const margins = useMemo(
		() => ({
			top: minMarginTop || 0,
			bottom: minMarginBottom || 0,
		}),
		[minMarginBottom, minMarginTop],
	)

	return [
		{
			visible: import.meta.env.SSR || visible,
			minMarginTop: relatedSections[0] === PageTemplateData.SORT_GROUPS.HEADER ? minMarginTop : null,
			minMarginBottom: relatedSections[1] === PageTemplateData.SORT_GROUPS.FOOTER ? minMarginBottom : null,
			rootProps,
			margins,
			ref,
		},
	]
}
